import React from 'react'
import {useIntl} from 'react-intl'
import {AzPageHeader} from '../../components/AzPageHeader'
import {NewslettersList} from './newsletters-list/NewslettersList'
import {ListViewProvider} from './newsletters-list/core/ListViewProvider'
import {QueryRequestProvider} from './newsletters-list/core/QueryRequestProvider'
import {QueryResponseProvider} from './newsletters-list/core/QueryResponseProvider'

const NewslettersPage = () => {
  const intl = useIntl()
  
  return (
    <>
      <AzPageHeader title={intl.formatMessage({id: 'MENU.NEWSLETTER'})} />
      <ListViewProvider>
        <QueryRequestProvider>
          <QueryResponseProvider>
            <NewslettersList />
          </QueryResponseProvider>
        </QueryRequestProvider>
      </ListViewProvider>
    </>
  )
}

export default NewslettersPage
